import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  wrapperBackgroundImage: {
    alignItems: 'center',
    background:
      "url('https://one.img.pmdstatic.net/fit/http.3A.2F.2Frec2-bone-image.2Es3-website-eu-west-1.2Eamazonaws.2Ecom.2Fcap.2F2020.2F12.2F11.2F0db5a9b3-2a0b-4dbe-83e9-562cf9b5a02a.2Ejpeg/800x450/quality/100/crop-from/top/transformation.jpg')",
    backgroundSize: 'cover',
    display: 'flex',
    height: '100vh',
    justifyContent: 'center',
    width: '100vw',
  },
  wrapperLogin: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    padding: 40,
  },
  svgIcon: {
    height: 50,
    marginBottom: 5,
    marginTop: 30,
  },
  oneWrapper: {
    color: theme.palette.common.black,
    fontSize: 15,
    fontWeight: 100,
    letterSpacing: 1,
    marginBottom: 30,
  },
  providers: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  azureButton: {
    textTransform: 'none',
    width: 280,
  },
  callbackMessage: {
    marginTop: theme.spacing(2),
  },
}));
